var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompetitionSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_235_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_236_",
    x: 110,
    y: 160,
    style: {
      fill: "#0052B4"
    },
    width: 100,
    height: 160
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_237_",
    x: 10,
    y: 260,
    style: {
      fill: "#0052B4"
    },
    width: 100,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_238_",
    x: 60,
    y: 260,
    style: {
      fill: "#006DF0"
    },
    width: 50,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_239_",
    x: 160,
    y: 160,
    style: {
      fill: "#78B9EB"
    },
    width: 50,
    height: 160
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_240_",
    style: {
      fill: "#FFDA44"
    },
    points: "210,160 160,160 160,130 180,130  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_241_",
    style: {
      fill: "#FF9811"
    },
    points: "110,160 160,160 160,130 140,130  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_242_",
    x: 210,
    y: 210,
    style: {
      fill: "#0052B4"
    },
    width: 100,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_243_",
    x: 260,
    y: 210,
    style: {
      fill: "#006DF0"
    },
    width: 50,
    height: 110
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_244_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_245_",
    style: {
      fill: "#BF720D"
    },
    cx: 90.361,
    cy: 68.461,
    r: 11.538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_307_",
    style: {
      fill: "#BF720D"
    },
    cx: 83.437,
    cy: 43.077,
    r: 23.077
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_308_",
    style: {
      fill: "#FFFFFF"
    },
    cx: 83.437,
    cy: 43.077,
    r: 9.231
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_309_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_311_",
    style: {
      fill: "#FF9811"
    },
    cx: 229.639,
    cy: 68.461,
    r: 11.538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_312_",
    style: {
      fill: "#FF9811"
    },
    cx: 236.562,
    cy: 43.077,
    r: 23.077
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_333_",
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.562,
    cy: 43.077,
    r: 9.231
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_334_",
    style: {
      fill: "#FFDA44"
    },
    d: "M90,17.272V30c0,38.66,31.34,70,70,70s70-31.34,70-70V17.272H90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_337_",
    style: {
      fill: "#FF9811"
    },
    d: "M160,17.272H90V30c0,38.66,31.34,70,70,70V17.272z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_338_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_340_",
    x: 90,
    style: {
      fill: "#BF720D"
    },
    width: 70,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_341_",
    x: 160,
    style: {
      fill: "#FF9811"
    },
    width: 70,
    height: 20
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_348_",
    x: 140,
    y: 90,
    style: {
      fill: "#FF9811"
    },
    width: 20,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_350_",
    x: 160,
    y: 90,
    style: {
      fill: "#FFDA44"
    },
    width: 20,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_351_",
    x: 140,
    y: 280,
    style: {
      fill: "#FF9811"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_352_",
    x: 160,
    y: 280,
    style: {
      fill: "#FFDA44"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_439_",
    x: 40,
    y: 280,
    style: {
      fill: "#FF9811"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_440_",
    x: 60,
    y: 280,
    style: {
      fill: "#FFDA44"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_441_",
    x: 240,
    y: 280,
    style: {
      fill: "#FF9811"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_443_",
    x: 260,
    y: 280,
    style: {
      fill: "#FFDA44"
    },
    width: 20,
    height: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionSvgrepoCom);
export default __webpack_public_path__ + "static/media/competition-svgrepo-com.6fe0c4d1dba606687686da860d53d426.svg";
export { ForwardRef as ReactComponent };